// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3McDP","content":"styles_content__fQexb"};